import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LegalNoticeResponseModel } from '../models/legal-notice-response.model';

const API_ENDPOINT = '/api/content/';

@Injectable({
  providedIn: 'root',
})
export class LegalNoticeService {

  /**
   * Constructor
   *
   * @param http [http]
   */
  public constructor(private http: HttpClient) {
  }

  /**
   * Gets a list of content items based on category
   *
   * @param {string} category
   *
   * @return Observable
   */
  public getItemList(category: string): Observable<LegalNoticeResponseModel> {
    // The response type should be moved to a separate class
    return this.http.get<{ error: string, items: LegalNoticeResponseModel }>(API_ENDPOINT + 'get/legal-notice/items/' + category)
      .pipe(
        map((response: { error: string, items: LegalNoticeResponseModel }) => {
          return response.items;
        }),
      );
  }

  /**
   * Get Available Legal Notice Categories
   *
   * @return {Observable<any>}
   */
  public getAvailable(): Observable<{ available: boolean, disclaimer: string, privacy_policy: string }> {
    // The response type should be moved to a separate class
    return this.http.get<{ error: string, items: { disclaimer?: string, privacy_policy?: string } }>(API_ENDPOINT + 'get/legal-notice/available')
      .pipe(
        map((response: { error: string, items: { disclaimer?: string, privacy_policy?: string } }) => {
          const available: boolean = (response.items.disclaimer !== undefined || response.items.privacy_policy !== undefined);
          return {
            disclaimer: response.items.disclaimer,
            privacy_policy: response.items.privacy_policy,
            available: available,
          };
        }),
      );
  }
}
